import { EstablishmentDto } from '../dto/establishment.dto';

export class Establishment {
  public isMaster: boolean;

  public static fromDto(establishmentDto: EstablishmentDto): Establishment {
    return new Establishment(establishmentDto.companyId, establishmentDto.name);
  }

  constructor(public companyId: number, public name: string) {}

  public isSameEstablishment(otherEstablishment: Establishment): boolean {
    return this.companyId === otherEstablishment.companyId;
  }
}
